import { defineMessages } from 'react-intl';

const messages = defineMessages({
  'footnote-physical-server': {
    id: 'H8/10h',
    defaultMessage:
      'A physical server is typically a physical computer that is comprised of processing units, memory, and input/output capabilities and that executes requested procedures, commands, or applications for one or more users or client devices. Where racks, blade enclosures, or other similar equipment is being employed, each separable physical device (for example, a blade or a rack-mounted device) that has the required components is considered itself a separate server.',
  },
  feedbackCharacters: {
    id: '0Bc7rz',
    defaultMessage: 'Characters.',
  },
  tier_2400M: {
    id: 'z9qHo4',
    defaultMessage: 'Up to 2400M',
  },
  feedbackInvalidMaximum: {
    id: '+uPBEM',
    defaultMessage: 'Maximum number of characters to process',
  },
  api_call_rounded_up: {
    id: 'E0CvBk',
    defaultMessage: 'API call Volume rounded up',
  },
  feedback500: {
    id: '4XFlJg',
    defaultMessage: 'Thank you, but something went wrong!',
  },
  inline_sws: {
    id: 'CI1KvW',
    defaultMessage: 'Software subscription information',
  },
  feedBackText: {
    id: 'XvuIXj',
    defaultMessage: 'Is this helpful:',
  },
  modalContinue: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  'thankyou.details-delivery': {
    id: '7UbQM1',
    defaultMessage: 'Delivery Option',
  },
  feedBackNotHelpfull: {
    id: '04tuTF',
    defaultMessage: 'Not helpful',
  },
  estimated_monthly_cost: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  getALiveDemo: {
    id: '1CJ3MC',
    defaultMessage: 'Request live demo',
  },
  handling_details1: {
    id: '8Kj9tz',
    defaultMessage: 'Unable to load price for',
  },
  api_call_dynamic_message_advanced_100M: {
    id: 'Vzz6yk',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 100M.',
  },
  handling_details2: {
    id: 'Md2HqZ',
    defaultMessage: 'Fetching local prices instead.',
  },
  api_call_dynamic_message_advanced_750M: {
    id: 'sjG4vm',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 750M.',
  },
  api_call_message_basic: {
    id: 'Yfc5Jv',
    defaultMessage:
      'This Offering is sold in increments of 100,000. The value you entered is rounded up for price estimation purposes.',
  },
  api_call_dynamic_message_advanced_500M: {
    id: 'XLnRkD',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 500M.',
  },
  request_a_quote: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  api_call_dynamic_message_advanced_2400M: {
    id: 'ZYJMXX',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 2400M.',
  },
  api_call_heading: {
    id: 'jEBbSq',
    defaultMessage: 'Estimated API call volume per year',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  thankyou_offering: {
    id: '6IX9se',
    defaultMessage: 'Offering Selected: ',
  },
  'footnote-headline-two': {
    id: '5PlN0b',
    defaultMessage: 'Total Servers in the Environment',
  },
  tier_750M: {
    id: 'aL+uc4',
    defaultMessage: 'Up to 750M',
  },
  'thankyou.details-title': {
    id: 'NWIE97',
    defaultMessage: 'Request details',
  },
  inline_saas: {
    id: 'pzhawg',
    defaultMessage: 'Software as a Service information',
  },
  'return-to-estimator': {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  summary_api_call_volume: {
    id: 'H75CH+',
    defaultMessage: 'API Call Volume',
  },
  'drawer-close': {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  tier_100M: {
    id: 'SwZGcT',
    defaultMessage: 'Up to 100M',
  },
  feedBackHelpfull: {
    id: '5vwKkg',
    defaultMessage: 'Helpful',
  },
  tier_500M: {
    id: 'TgNehD',
    defaultMessage: 'Up to 500M',
  },
  handling_contact: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  button_contact_us: {
    id: 'hZOGLS',
    defaultMessage: 'Contact Us',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  summary_bucket_to_volume: {
    id: 'doFd3h',
    defaultMessage: 'Tier to purchase',
  },
  feedbackEmailHolder: {
    id: 'Q75vbh',
    defaultMessage: 'Example: yourEmail@ibm.com',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  thankyou_private_data_connectivity: {
    id: 'OpdlyH',
    defaultMessage: 'Private Data Connectivity: ',
  },
  role: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  configuration: {
    id: '7OW8BT',
    defaultMessage: 'Configuration',
  },
  'thankyou.details-servers': {
    id: '+YXKBO',
    defaultMessage: 'Total Workstations or Employees',
  },
  'thankyou.details-selected-bp': {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  feedback203: {
    id: '7FTPXh',
    defaultMessage: 'Sorry, I could sent the feedback!',
  },
  'thankyou.details-consent-bp': {
    id: 'oZz635',
    defaultMessage:
      'I consent to IBM providing my business contact information',
  },
  feedbackComment: {
    id: '4FQrdH',
    defaultMessage: 'Comment:',
  },
  heading_reserved_software: {
    id: 'UEzhcr',
    defaultMessage:
      'For reserved and software options, contact us to get custom pricing.',
  },
  heading_two: {
    id: 'woJrvN',
    defaultMessage: 'Select your Offering option:',
  },
  contact_us_monthy_cost: {
    id: '5tuT1j',
    defaultMessage: 'Contact us to get custom pricing',
  },
  feedbackEmail: {
    id: 'zuu8pi',
    defaultMessage: 'Email (optional):',
  },
  tier_250M: {
    id: 'F/BW5B',
    defaultMessage: 'Up to 250M',
  },
  tooltip_base: {
    id: 'eKXwun',
    defaultMessage: 'Multi-tenant offering hosted on AWS.',
  },
  summary_data_connectivity: {
    id: 'nAUOoC',
    defaultMessage: 'Private Data Connectivity',
  },
  feedbackHeaderText: {
    id: 'qxui/f',
    defaultMessage: 'Feedback form',
  },
  feedback200: {
    id: 'FxvkF9',
    defaultMessage: 'Thank you! Your feedback was sent',
  },
  summary_offer_selecting: {
    id: 'r1n+gM',
    defaultMessage: 'Offering selected',
  },
  api_call_dynamic_message_advanced_1200M: {
    id: 'HJ2Y3K',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 1200M.',
  },
  'thankyou.title': {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  'thankyou.details-employees': {
    id: '+YXKBO',
    defaultMessage: 'Total Workstations or Employees',
  },
  value: {
    id: 'GufXy5',
    defaultMessage: 'Value',
  },
  feedbackInvalidMinimum: {
    id: 'fkJa3C',
    defaultMessage: 'Minimum number of characters to process',
  },
  licences: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  api_call_static_message_advanced: {
    id: 'MHMkVz',
    defaultMessage:
      'This Offering is sold in increments. The value you entered is rounded up to the closest tier for price estimation purposes.',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  heading_one: {
    id: '8VwNnL',
    defaultMessage:
      'Estimate your API Connect price based on the scope of your needs:',
  },
  feedbackSubmit: {
    id: 'wSZR47',
    defaultMessage: 'Submit',
  },
  feedbackCancel: {
    id: '47FYwb',
    defaultMessage: 'Cancel',
  },
  'thankyou.subtitle': {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  feedbackInvalidEmail: {
    id: 'HBERi+',
    defaultMessage: 'Invalid email.',
  },
  feddbackPhraseText: {
    id: 'yI2J2z',
    defaultMessage:
      'Please provide your thoughts about what we can do to better?',
  },
  footnoteOne: {
    id: '3qN7sH',
    defaultMessage:
      'Estimated costs are not a formal offer from IBM or an IBM Business Partner. Certain factors such as API Connect configuration, add-ons, and discounts may affect estimated costs. IBM Business Partners set and provide their own IBM API Connect pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  tooltip_workstations: {
    id: 'LzpZFf',
    defaultMessage: 'If your organization has more than 10000 employees please',
  },
  'footnote-virtual-server': {
    id: '507u0l',
    defaultMessage:
      'A virtual server is a virtual computer created by logically partitioning physical resources into sub-computers that execute requested procedures, commands, or applications for one or more users or client devices.',
  },
  tier_1200M: {
    id: '9Az6yu',
    defaultMessage: 'Up to 1200M',
  },
  option_slider_2: {
    id: 'VEKZbe',
    defaultMessage: 'Estimated number of API to manage',
  },
  api_call_dynamic_message_advanced_250M: {
    id: 'rJIogt',
    defaultMessage:
      'For your selected API Call volume, you require to purchase the tier Up to 250M.',
  },
  asteriskPrice: {
    id: 'WDVZ09',
    defaultMessage:
      'Estimated prices do not include tax and are for new API Connect customers, initial purchase only. Tiered discounts may be available based on volumes.',
  },
  handling_title: {
    id: 'g7hhSR',
    defaultMessage: "Sorry, this shouldn't happen.",
  },
  option_slider_3: {
    id: 'YrvfTn',
    defaultMessage: 'Estimated number of API consumers',
  },
  feedbackCommentHolder: {
    id: '6jv80B',
    defaultMessage: 'Your comments here...',
  },
  advanced_data_connectivity: {
    id: 'DIMLhE',
    defaultMessage: 'Do you require Private Data Connectivity?',
  },
  modalResponseText: {
    id: 'MgdnPi',
    defaultMessage: 'Response',
  },
  option_slider_1: {
    id: 'npggE2',
    defaultMessage: 'Estimated number of environments',
  },
  tooltip_reserved: {
    id: 'zncOX3',
    defaultMessage:
      'Fully single tenant offering hosted on IBM Cloud that meets greater isolation and availability requirements, and includes advanced capabilities.',
  },
  tooltip_advanced: {
    id: 'ytgub2',
    defaultMessage:
      'Multi-tenant offering hosted on AWS with a single tenant gateway and advanced capabilities.',
  },
  footnotes: {
    id: 't1Ql7Y',
    defaultMessage: 'Footnotes',
  },
});

export default messages;
